import {Link as RouterLink} from "@tanstack/react-router";

export interface WasteRouterLinkProps {
    wasteId: string;
}

export function WasteRouterLink({wasteId}: WasteRouterLinkProps) {
    return <RouterLink to="/waste/$id/cargo" params={{id: wasteId}}/>
}